import { render } from "./AppLoader.vue?vue&type=template&id=b2ab75de&scoped=true"
const script = {}

import "./AppLoader.vue?vue&type=style&index=0&id=b2ab75de&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2ab75de"]])

export default __exports__